export default __webpack_public_path__ + "static/maciejb-c749e2974acf1d9236e21c1329314938.jpg";